module.exports = __webpack_public_path__ + "img/beaker-01.8728a044.svg";